import React, { useState } from 'react';
import { useTheme } from '../../utils/theme';
import { useTranslation } from '../../utils/i18n';

export function ChatForm({ onSubmit, isLoading, error }) {
  const { theme } = useTheme();
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    contact: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const isDark = theme === 'dark';

  return (
    <div className="flex h-full flex-col p-6">
      <h3 className={`text-xl font-semibold mb-4 ${isDark ? 'text-white' : 'text-indigo-900'}`}>
        {t('chat.welcome')}
      </h3>
      <p className={`text-sm mb-6 ${isDark ? 'text-blue-200' : 'text-gray-600'}`}>
        {t('chat.fill_info')}
      </p>

      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <div>
          <label
            htmlFor="name"
            className={`block text-sm font-medium mb-1 ${isDark ? 'text-blue-200' : 'text-gray-700'}`}
          >
            {t('chat.name')}
          </label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            className={`w-full rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 ${
              isDark
                ? 'bg-blue-950/50 border border-blue-700 text-white placeholder:text-blue-400 focus:ring-blue-500'
                : 'bg-white border border-indigo-200 text-gray-900 placeholder:text-gray-400 focus:ring-indigo-500'
            }`}
            placeholder={t('chat.name_placeholder')}
          />
        </div>

        <div>
          <label
            htmlFor="email"
            className={`block text-sm font-medium mb-1 ${isDark ? 'text-blue-200' : 'text-gray-700'}`}
          >
            {t('chat.email')}
          </label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            className={`w-full rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 ${
              isDark
                ? 'bg-blue-950/50 border border-blue-700 text-white placeholder:text-blue-400 focus:ring-blue-500'
                : 'bg-white border border-indigo-200 text-gray-900 placeholder:text-gray-400 focus:ring-indigo-500'
            }`}
            placeholder={t('chat.email_placeholder')}
          />
        </div>

        <div>
          <label
            htmlFor="contact"
            className={`block text-sm font-medium mb-1 ${isDark ? 'text-blue-200' : 'text-gray-700'}`}
          >
            {t('chat.contact')}
          </label>
          <input
            type="tel"
            id="contact"
            name="contact"
            value={formData.contact}
            onChange={handleChange}
            required
            className={`w-full rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 ${
              isDark
                ? 'bg-blue-950/50 border border-blue-700 text-white placeholder:text-blue-400 focus:ring-blue-500'
                : 'bg-white border border-indigo-200 text-gray-900 placeholder:text-gray-400 focus:ring-indigo-500'
            }`}
            placeholder={t('chat.contact_placeholder')}
          />
        </div>

        {error && (
          <div className={`rounded-lg border px-3 py-2 text-sm ${
            isDark
              ? 'bg-red-900/30 border-red-700 text-red-200'
              : 'bg-rose-50 border-rose-300 text-rose-800'
          }`}>
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={isLoading}
          className={`mt-2 w-full rounded-lg px-4 py-2 text-sm font-semibold transition-colors ${
            isDark
              ? 'bg-white text-blue-900 hover:bg-gray-100 disabled:bg-gray-400'
              : 'bg-indigo-600 text-white hover:bg-indigo-700 disabled:bg-indigo-300'
          }`}
        >
          {isLoading ? t('chat.starting') : t('chat.start_chat')}
        </button>
      </form>
    </div>
  );
}
